const keyboardDatePickerModalFilterService = {
  from: 'From',
  to: 'To'
};

export default keyboardDatePickerModalFilterService;
